export const HTTPS = "https";

export const apacCountriesKey = {
  "hong-kong": "hong-kong",
  singapore: "singapore",
  australia: "australia"
};

export const apacCountries = {
  [apacCountriesKey["hong-kong"]]: "Hong Kong",
  [apacCountriesKey.singapore]: "Singapore",
  [apacCountriesKey.australia]: "Australia"
};

export const TYPES = {
  BUTTON: "BUTTON",
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  LINK: "LINK",
  TEXT_LINK: "TEXT_LINK",
  SCANNER: "SCANNER",
  TWITTER: "TWITTER",
  LINKEDIN: "LINKEDIN",
  ATTACHMENT: "ATTACHMENT"
};

export const PAGE_SLUGS = {
  HOMEPAGE: "homepage"
};

export const GREENHOUSE_EMBED_BASE_URL =
  "https://boards.greenhouse.io/embed/job_app?for=gemini&token=";

export const COMPONENT_TYPES = {
  BREADCRUMB: "BREADCRUMB",
  COIN_RESOURCES: "COIN-RESOURCES",
  ABOUT_ACCORDION: "ABOUT-ACCORDION",
  FAQ_ACCORDION: "FAQ-ACCORDION",
  INVESTMENT_SMALL_CARD: "INVESTMENT-SMALL-CARD",
  CRYPTOPEDIA_SMALL_CARD: "CRYPTOPEDIA-SMALL-CARD",
  PRICE_BLOG: "PRICE-BLOG",
  PRICE_ARTICLE: "PRICE-ARTICLE",
  TRADE_FORM: "TRADE-FORM",
  ABOUT_COIN: "ABOUT-COIN"
};

export const URLS = {
  CREDIT_CARD_APPLY: "https://creditcard.exchange.gemini.com/credit-card/apply",
  REGISTER: "https://exchange.gemini.com/register",
  COIN_BLOG: "https://www.gemini.com/blog/search?query={COIN}",
  COIN_CRYPTOPEDIA: "https://www.gemini.com/cryptopedia/search?query={COIN}"
};

// relevant to careers and early-careers/ internships page of builder.io
export const CAREERS_STICKY_NAV_ITEMS_IDS = {
  WORK_AT_GEMINI: "work-at-gemini",
  EARLY_CAREERS: "early-careers",
  OPEN_ROLES: "open-roles"
};
